const Raffles = ()=>{
    return <>
        <h2 className="txtcenter">Coming Soon..!! Stay Tuned...</h2>
    </>
}

export default Raffles